var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d2-avatar-uploader" },
    [
      _c(
        "el-upload",
        {
          class: { "is-empty": _vm.isEmpty },
          style: _vm.styleUploader,
          attrs: {
            action: "https://jsonplaceholder.typicode.com/posts/",
            "show-file-list": false,
            "before-upload": _vm.beforeUpload
          }
        },
        [
          _vm.currentValue
            ? _c("img", {
                staticClass: "avatar",
                style: _vm.styleAvatar,
                attrs: { src: _vm.currentValue }
              })
            : _c("i", {
                staticClass: "el-icon-plus icon",
                style: _vm.styleIcon
              })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }